import { APP_CONFIG_GLOBAL_KEY } from '../constants/app-config.constants';
import type { AppConfig } from '../types/app-config.types';
import type { AppConfigSource } from '../types/app-config-source.types';
import { mapRawConfigToAppConfig } from '../utils/map-raw-config-to-app-config.util';

export class BrowserGlobalAdapter implements AppConfigSource {
	public read(): AppConfig {
		if (typeof globalThis === 'undefined') {
			return {};
		}

		const runtimeGlobal = globalThis as typeof globalThis & {
			[APP_CONFIG_GLOBAL_KEY]?: AppConfig | Record<string, unknown>;
		};

		const runtimeConfig = runtimeGlobal[APP_CONFIG_GLOBAL_KEY];

		if (!runtimeConfig) {
			return {};
		}

		if (this.isRawRuntimeConfig(runtimeConfig)) {
			return mapRawConfigToAppConfig(runtimeConfig);
		}

		return runtimeConfig;
	}

	private isRawRuntimeConfig(
		value: AppConfig | Record<string, unknown>
	): value is Record<string, unknown> {
		return Object.keys(value).some((key) => key.startsWith('VITE_'));
	}
}
